import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import TechPill from './TechPill';

function ProjectCard({ project }) {
  const fallbackImage = "/images/projects/fallback.png";

  return (
    <div className="project-card">
      <div className="project-image">
        <div className="image-wrapper">
          <img
            src={project.image || fallbackImage}
            alt={project.title}
            loading="lazy"
            width={400}
            height={225}
            onError={(e) => {
              e.target.src = fallbackImage;
            }}
          />
        </div>
      </div>
      <div className="project-content">
        <div className="project-header">
          <h3 className="project-title">
            {(() => {
              const link = project.paperLink || project.external;
              if (link) {
                return (
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="company-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {project.title}
                    <FiArrowUpRight className="title-arrow" />
                  </a>
                );
              }
              return project.title;
            })()}
          </h3>
        </div>
        <p className="project-description">{project.description}</p>
        <div className="tech-list">
          {project.tech.map((tech, i) => (
            <TechPill key={i} tech={tech} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectCard; 